<!-- @format -->

<div class="admin-header-bg">
	<div style="background: #000">
		<div class="container p-3">
			<div class="ad-header-margin">
				<img
					(click)="home()"
					src="/assets/img/anam-logo.png"
					class="logo"
					alt="Brand Logo"
					height="46"
				/>

				<div class="d-flex flex-row align-items-center">
					<div class="notification-item me-4 hide-sm">
						<div
							(click)="toggleNotification()"
							style="cursor: pointer"
						>
							<img
								src="assets/notification/notification-bell.png"
								style="width: 40px; height: 40px"
							/>
							<span>{{ total }}</span>
						</div>
						<div
							class="notify-toggle"
							*ngIf="isNotifyOpen"
						>
							<!-- each div here represents each notification item -->
							<div *ngFor="let s of notification">
								<div
									class="notify-item"
									href="javascript:void(0)"
									*ngIf="notification"
								>
									<img
										class="me-3"
										src="assets/notification/check-item.png"
										style="width: 30px; height: 30px"
										(click)="notify('INACTIVE', s.id)"
									/>
									<div class="span">
										<b
											style="font-size: 13px"
											class="mb-1"
											>{{ s.subject }}</b
										>
										<p>{{ s.message }}</p>
										<small
											>Time -
											{{
												s.timeCreated | datetime
											}}</small
										>
									</div>
									<svg
										(click)="notify('DELETED', s.id)"
										width="20"
										height="20"
										viewBox="0 0 8 10"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1.90108 9.19043C1.6608 9.19043 1.46022 9.10999 1.29934 8.94911C1.13811 8.78788 1.0575 8.58713 1.0575 8.34685V1.87767H0.535156V1.35533H2.62452V0.953125H5.75856V1.35533H7.84792V1.87767H7.32558V8.34685C7.32558 8.58713 7.24514 8.78771 7.08426 8.94859C6.92303 9.10982 6.72228 9.19043 6.482 9.19043H1.90108ZM3.04657 7.62341H3.56891V2.92235H3.04657V7.62341ZM4.81417 7.62341H5.33651V2.92235H4.81417V7.62341Z"
											fill="#F24E1E"
										/>
									</svg>
								</div>
							</div>
						</div>
					</div>

					<div
						ngbDropdown
						#dropdown="ngbDropdown"
						[open]="isDropdownOpen"
						(mouseenter)="isDropdownOpen = true"
						(mouseleave)="isDropdownOpen = false"
						class="d-inline-block"
						style="margin-right: 20px"
					>
						<b
							class="text-white x-hidden d-flex align-items-center"
							ngbDropdownToggle
							style="font-size: 14px; cursor: pointer"
						>
							{{ displayName | uppercase }}
							<i
								class="bi bi-caret-down-fill ms-2"
								style="font-size: 1.3rem"
							></i>
						</b>
						<div
							ngbDropdownMenu
							class="dropdown-menu dropdown-menu-end p-2"
							style="min-width: 150px"
						>
							<button
								class="dropdown-item dropdown-item-custom"
								(click)="changePassword()"
							>
								<i class="bi bi-key me-2"></i> Change Password
							</button>
						</div>
					</div>

					<a
						href="#"
						style="margin-right: 20px"
						class="hide-sm"
					>
						<svg
							width="54"
							height="20"
							viewBox="0 0 54 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect
								width="54"
								height="20"
								rx="10"
								fill="#FFF8E7"
							/>
							<g clip-path="url(#clip0_398_159)">
								<g clip-path="url(#clip1_398_159)">
									<path
										d="M15 15C17.7614 15 20 12.7614 20 10C20 7.23858 17.7614 5 15 5C12.2386 5 10 7.23858 10 10C10 12.7614 12.2386 15 15 15Z"
										stroke="#A07C09"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M13.5449 8.49998C13.6625 8.16581 13.8945 7.88403 14.1999 7.70455C14.5053 7.52506 14.8644 7.45945 15.2135 7.51934C15.5627 7.57922 15.8793 7.76074 16.1075 8.03174C16.3356 8.30275 16.4604 8.64574 16.4599 8.99998C16.4599 9.99998 14.9599 10.5 14.9599 10.5M14.9999 12.5H15.0049"
										stroke="#A07C09"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</g>
							</g>
							<path
								d="M23.799 14V6.72727H24.8963V9.88778H28.522V6.72727H29.6229V14H28.522V10.8288H24.8963V14H23.799ZM33.4865 14.1101C32.9491 14.1101 32.4863 13.9953 32.098 13.7656C31.7121 13.5336 31.4138 13.2081 31.2031 12.7891C30.9948 12.3677 30.8906 11.8741 30.8906 11.3082C30.8906 10.7495 30.9948 10.2571 31.2031 9.83097C31.4138 9.40483 31.7074 9.07221 32.0838 8.8331C32.4626 8.59399 32.9053 8.47443 33.4119 8.47443C33.7197 8.47443 34.018 8.52533 34.3068 8.62713C34.5956 8.72893 34.8549 8.88873 35.0845 9.10653C35.3142 9.32434 35.4953 9.60724 35.6278 9.95526C35.7604 10.3009 35.8267 10.7211 35.8267 11.2159V11.5923H31.4908V10.7969H34.7862C34.7862 10.5175 34.7294 10.2701 34.6158 10.0547C34.5021 9.83688 34.3423 9.66525 34.1364 9.53977C33.9328 9.4143 33.6937 9.35156 33.419 9.35156C33.1207 9.35156 32.8603 9.42495 32.6378 9.57173C32.4176 9.71615 32.2472 9.90554 32.1264 10.1399C32.008 10.3719 31.9489 10.6241 31.9489 10.8963V11.5178C31.9489 11.8823 32.0128 12.1925 32.1406 12.4482C32.2708 12.7038 32.4519 12.8991 32.6839 13.0341C32.916 13.1667 33.187 13.233 33.4972 13.233C33.6984 13.233 33.8819 13.2045 34.0476 13.1477C34.2133 13.0885 34.3565 13.0009 34.4773 12.8849C34.598 12.7689 34.6903 12.6257 34.7543 12.4553L35.7592 12.6364C35.6787 12.9323 35.5343 13.1915 35.326 13.4141C35.12 13.6342 34.8608 13.8059 34.5483 13.929C34.2382 14.0497 33.8842 14.1101 33.4865 14.1101ZM38.0666 6.72727V14H37.0048V6.72727H38.0666ZM39.495 16.0455V8.54545H40.532V9.42969H40.6207C40.6823 9.31605 40.7711 9.18466 40.8871 9.03551C41.0031 8.88636 41.1641 8.75616 41.37 8.64489C41.576 8.53125 41.8482 8.47443 42.1868 8.47443C42.6271 8.47443 43.0201 8.5857 43.3658 8.80824C43.7114 9.03078 43.9825 9.35156 44.179 9.7706C44.3778 10.1896 44.4773 10.6939 44.4773 11.2834C44.4773 11.8729 44.379 12.3783 44.1825 12.7997C43.986 13.2187 43.7161 13.5419 43.3729 13.7692C43.0296 13.9941 42.6378 14.1065 42.1974 14.1065C41.866 14.1065 41.5949 14.0509 41.3842 13.9396C41.1759 13.8284 41.0125 13.6982 40.8942 13.549C40.7758 13.3999 40.6847 13.2673 40.6207 13.1513H40.5568V16.0455H39.495ZM40.5355 11.2727C40.5355 11.6562 40.5911 11.9924 40.7024 12.2812C40.8137 12.5701 40.9747 12.7962 41.1854 12.9595C41.3961 13.1205 41.6541 13.201 41.9595 13.201C42.2768 13.201 42.5419 13.117 42.755 12.9489C42.968 12.7784 43.129 12.5476 43.2379 12.2564C43.3492 11.9652 43.4048 11.6373 43.4048 11.2727C43.4048 10.9129 43.3504 10.5897 43.2415 10.3033C43.1349 10.0168 42.974 9.79072 42.7585 9.625C42.5455 9.45928 42.2791 9.37642 41.9595 9.37642C41.6518 9.37642 41.3913 9.45573 41.1783 9.61435C40.9676 9.77296 40.8078 9.99432 40.6989 10.2784C40.59 10.5625 40.5355 10.8939 40.5355 11.2727Z"
								fill="#846500"
							/>
							<defs>
								<clipPath id="clip0_398_159">
									<rect
										width="12"
										height="12"
										fill="white"
										transform="translate(9 4)"
									/>
								</clipPath>
								<clipPath id="clip1_398_159">
									<rect
										width="12"
										height="12"
										fill="white"
										transform="translate(9 4)"
									/>
								</clipPath>
							</defs>
						</svg>
					</a>
					<a
						style="margin-right: 20px; cursor: pointer"
						(click)="logout()"
					>
						<svg
							width="89"
							height="30"
							viewBox="0 0 69 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect
								width="69"
								height="20"
								rx="10"
								fill="#343a40"
							/>
							<g clip-path="url(#clip0_398_152)">
								<path
									d="M16.5434 7.46375V6.19563C16.5434 6.09954 16.5052 6.00738 16.4373 5.93943C16.3693 5.87149 16.2772 5.83331 16.1811 5.83331H12.1956C12.0995 5.83331 12.0073 5.87149 11.9394 5.93943C11.8714 6.00738 11.8333 6.09954 11.8333 6.19563V13.8043C11.8333 13.9004 11.8714 13.9926 11.9394 14.0605C12.0073 14.1285 12.0995 14.1666 12.1956 14.1666H16.1811C16.2772 14.1666 16.3693 14.1285 16.4373 14.0605C16.5052 13.9926 16.5434 13.9004 16.5434 13.8043V12.5362"
									stroke="white"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									d="M20.1665 10H13.2825"
									stroke="white"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									d="M18.355 11.8116L20.1666 10L18.355 8.18842"
									stroke="white"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</g>
							<path
								d="M24.799 14V6.72727H25.8963V13.0554H29.1918V14H24.799ZM32.6559 14.1101C32.1445 14.1101 31.6983 13.9929 31.3171 13.7585C30.936 13.5241 30.64 13.1963 30.4293 12.7749C30.2186 12.3535 30.1133 11.861 30.1133 11.2976C30.1133 10.7318 30.2186 10.237 30.4293 9.81321C30.64 9.38944 30.936 9.06037 31.3171 8.82599C31.6983 8.59162 32.1445 8.47443 32.6559 8.47443C33.1673 8.47443 33.6135 8.59162 33.9947 8.82599C34.3758 9.06037 34.6718 9.38944 34.8825 9.81321C35.0932 10.237 35.1985 10.7318 35.1985 11.2976C35.1985 11.861 35.0932 12.3535 34.8825 12.7749C34.6718 13.1963 34.3758 13.5241 33.9947 13.7585C33.6135 13.9929 33.1673 14.1101 32.6559 14.1101ZM32.6594 13.2188C32.9909 13.2188 33.2655 13.1312 33.4833 12.956C33.7011 12.7808 33.8621 12.5476 33.9663 12.2564C34.0728 11.9652 34.1261 11.6444 34.1261 11.294C34.1261 10.946 34.0728 10.6264 33.9663 10.3352C33.8621 10.0417 33.7011 9.80611 33.4833 9.62855C33.2655 9.45099 32.9909 9.36222 32.6594 9.36222C32.3256 9.36222 32.0487 9.45099 31.8285 9.62855C31.6107 9.80611 31.4485 10.0417 31.342 10.3352C31.2378 10.6264 31.1857 10.946 31.1857 11.294C31.1857 11.6444 31.2378 11.9652 31.342 12.2564C31.4485 12.5476 31.6107 12.7808 31.8285 12.956C32.0487 13.1312 32.3256 13.2188 32.6594 13.2188ZM38.6706 16.1591C38.2374 16.1591 37.8645 16.1023 37.552 15.9886C37.2419 15.875 36.9886 15.7247 36.7921 15.5376C36.5956 15.3506 36.4488 15.1458 36.3517 14.9233L37.2644 14.5469C37.3283 14.651 37.4135 14.7611 37.5201 14.8771C37.629 14.9955 37.7757 15.0961 37.9604 15.179C38.1474 15.2618 38.3877 15.3033 38.6813 15.3033C39.0837 15.3033 39.4164 15.205 39.6792 15.0085C39.9419 14.8144 40.0733 14.5043 40.0733 14.0781V13.0057H40.0059C39.9419 13.1217 39.8496 13.2507 39.7289 13.3928C39.6105 13.5348 39.4471 13.6579 39.2388 13.7621C39.0305 13.8662 38.7594 13.9183 38.4256 13.9183C37.9947 13.9183 37.6065 13.8177 37.2608 13.6165C36.9176 13.4129 36.6453 13.1134 36.4441 12.718C36.2452 12.3203 36.1458 11.8314 36.1458 11.2514C36.1458 10.6714 36.244 10.1742 36.4405 9.75994C36.6394 9.34564 36.9116 9.02841 37.2573 8.80824C37.6029 8.5857 37.9947 8.47443 38.4327 8.47443C38.7712 8.47443 39.0447 8.53125 39.253 8.64489C39.4614 8.75616 39.6235 8.88636 39.7395 9.03551C39.8579 9.18466 39.949 9.31605 40.013 9.42969H40.0911V8.54545H41.1316V14.1207C41.1316 14.5895 41.0227 14.9742 40.8049 15.2749C40.5871 15.5755 40.2923 15.7981 39.9206 15.9425C39.5513 16.0869 39.1346 16.1591 38.6706 16.1591ZM38.66 13.0376C38.9654 13.0376 39.2234 12.9666 39.4341 12.8246C39.6472 12.6802 39.8082 12.4742 39.9171 12.2067C40.0283 11.9368 40.084 11.6136 40.084 11.2372C40.084 10.8703 40.0295 10.5471 39.9206 10.2678C39.8117 9.9884 39.6519 9.7706 39.4412 9.61435C39.2305 9.45573 38.9701 9.37642 38.66 9.37642C38.3404 9.37642 38.074 9.45928 37.861 9.625C37.6479 9.78835 37.4869 10.0109 37.378 10.2926C37.2715 10.5743 37.2182 10.8892 37.2182 11.2372C37.2182 11.5947 37.2727 11.9084 37.3816 12.1783C37.4905 12.4482 37.6515 12.6589 37.8645 12.8104C38.08 12.9619 38.3451 13.0376 38.66 13.0376ZM44.8532 14.1101C44.3418 14.1101 43.8955 13.9929 43.5144 13.7585C43.1332 13.5241 42.8373 13.1963 42.6266 12.7749C42.4159 12.3535 42.3105 11.861 42.3105 11.2976C42.3105 10.7318 42.4159 10.237 42.6266 9.81321C42.8373 9.38944 43.1332 9.06037 43.5144 8.82599C43.8955 8.59162 44.3418 8.47443 44.8532 8.47443C45.3645 8.47443 45.8108 8.59162 46.1919 8.82599C46.5731 9.06037 46.869 9.38944 47.0797 9.81321C47.2904 10.237 47.3958 10.7318 47.3958 11.2976C47.3958 11.861 47.2904 12.3535 47.0797 12.7749C46.869 13.1963 46.5731 13.5241 46.1919 13.7585C45.8108 13.9929 45.3645 14.1101 44.8532 14.1101ZM44.8567 13.2188C45.1882 13.2188 45.4628 13.1312 45.6806 12.956C45.8984 12.7808 46.0594 12.5476 46.1635 12.2564C46.2701 11.9652 46.3233 11.6444 46.3233 11.294C46.3233 10.946 46.2701 10.6264 46.1635 10.3352C46.0594 10.0417 45.8984 9.80611 45.6806 9.62855C45.4628 9.45099 45.1882 9.36222 44.8567 9.36222C44.5229 9.36222 44.2459 9.45099 44.0257 9.62855C43.8079 9.80611 43.6458 10.0417 43.5392 10.3352C43.4351 10.6264 43.383 10.946 43.383 11.294C43.383 11.6444 43.4351 11.9652 43.5392 12.2564C43.6458 12.5476 43.8079 12.7808 44.0257 12.956C44.2459 13.1312 44.5229 13.2188 44.8567 13.2188ZM52.0362 11.7379V8.54545H53.1016V14H52.0575V13.0554H52.0007C51.8752 13.3466 51.674 13.5893 51.397 13.7834C51.1224 13.9751 50.7803 14.071 50.3707 14.071C50.0204 14.071 49.7102 13.9941 49.4403 13.8402C49.1728 13.6839 48.9621 13.4531 48.8082 13.1477C48.6567 12.8423 48.581 12.4647 48.581 12.0149V8.54545H49.6428V11.8871C49.6428 12.2588 49.7457 12.5547 49.9517 12.7749C50.1577 12.995 50.4252 13.1051 50.7543 13.1051C50.9531 13.1051 51.1508 13.0554 51.3473 12.956C51.5462 12.8565 51.7107 12.7062 51.8409 12.505C51.9735 12.3037 52.0386 12.0481 52.0362 11.7379ZM57.0744 8.54545V9.39773H54.095V8.54545H57.0744ZM54.894 7.23864H55.9558V12.3984C55.9558 12.6044 55.9866 12.7595 56.0481 12.8636C56.1097 12.9654 56.189 13.0353 56.286 13.0732C56.3855 13.1087 56.4932 13.1264 56.6092 13.1264C56.6944 13.1264 56.769 13.1205 56.8329 13.1087C56.8968 13.0968 56.9466 13.0874 56.9821 13.0803L57.1738 13.9574C57.1123 13.9811 57.0247 14.0047 56.911 14.0284C56.7974 14.0545 56.6554 14.0687 56.4849 14.071C56.2056 14.0758 55.9451 14.026 55.7037 13.9219C55.4622 13.8177 55.2669 13.6567 55.1177 13.4389C54.9686 13.2211 54.894 12.9477 54.894 12.6186V7.23864Z"
								fill="white"
							/>
							<defs>
								<clipPath id="clip0_398_152">
									<rect
										width="10"
										height="10"
										fill="white"
										transform="translate(11 5)"
									/>
								</clipPath>
							</defs>
						</svg>
					</a>
				</div>
			</div>
		</div>
	</div>

	<nav
		class="navbar navbar-expand-xxl navbar-light"
		style="background: #cc9d10"
	>
		<div class="container">
			<button
				class="navbar-toggler"
				type="button"
				aria-controls="navbarContent"
				[attr.aria-expanded]="!collapsed"
				aria-label="Toggle navigation"
				(click)="collapsed = !collapsed"
			>
				<span class="navbar-toggler-icon"></span>
			</button>

			<div
				class="navbar-collapse justify-content-start"
				[class.collapse]="collapsed"
				id="navbarContent"
			>
				<ul class="navbar-nav">
					<li class="nav-item me-3">
						<a
							[routerLink]="['/admin/dashboard']"
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							>Dashboard</a
						>
					</li>
					<li
						*ngIf="hasAccess(['ALL_PERMISSIONS'])"
						class="nav-item me-3"
						style="white-space: nowrap; display: inline-block"
					>
						<a
							href="#"
							class="nav-link links"
							[routerLink]="['/general/audit-trail']"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							>Audit-Trail</a
						>
					</li>

					<li class="nav-item me-3">
						<a
							[routerLink]="['/general/verification']"
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							>Verifications</a
						>
					</li>

					<li
						class="nav-item me-3"
						ngbDropdown
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_MANAGE_TAXPAYER',
								'SPLIT_ADMIN',
								'CAN_MERGE_ASIN',
								'CAN_MANAGE_ROLES',
								'CAN_CHANGE_USER_EMAIL',
								'CAN_VIEW_BACK_OFFICE'
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown1"
							role="button"
						>
							Back Office
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown1"
							class="dropdown-menu"
						>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_CHANGE_USER_EMAIL',
										'CAN_MERGE_ASIN',
										'CAN_VIEW_SUPPORT_ADMIN'
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/support']"
								>Support</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'SPLIT_ADMIN',
										'CAN_MANAGE_ROLES',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/role-management']"
								>Role Management</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_MANAGE_TAXPAYER',
									])
								"
								class="subLinks"
								class="subLinks"
								ngbDropdownItem
								[routerLink]="['/admin/user-management']"
								>Users Management</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_SET_WORKFLOW',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/workflow-management']"
								>Workflow Settings</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'SPLIT_ADMIN',
										'CAN_MANAGE_ROLES',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/mda-zones']"
								>MDA Zones</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_MANAGE_TAXPAYER',
									])
								"
								class="subLinks"
								class="subLinks"
								ngbDropdownItem
								[routerLink]="['/admin/mda-stations']"
								>MDA Stations</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_SET_WORKFLOW',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/mda-features']"
								>MDA Features
							</a>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_RECYCLE_BIN',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/recycle-bin']"
								>Recycle Bin</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/reconciliations/asin-reconciliation',
								]"
                                *ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ASIN_RECONCILIATION',
									])
								"
							>
								ASIN Reconciliation
							</a>
							<a
								*ngIf="hasAccess(['ALL_PERMISSIONS'])"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/send/bulk-email']"
							>
								Bulk E-mail
							</a>
							<a
								*ngIf="hasAccess(['SPLIT_ADMIN'])"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/split-configuration']"
							>
								Split Configuration
							</a>
							<a
								*ngIf="hasAccess(['ALL_PERMISSIONS'])"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/penalty-management']"
							>
								Penalty Management
							</a>
						</div>
					</li>

					<li class="nav-item me-3">
						<a
							[routerLink]="['/general/user-management-informal']"
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							>Taxpayers</a
						>
					</li>

					<li
						class="nav-item"
						ngbDropdown
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_VIEW_OTHER_TAXES',
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown5"
							role="button"
							>Other Taxes
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown5"
							class="dropdown-menu"
						>
							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_OTHER_TAXES',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="capitalGainsDropdown"
									role="button"
									>Capital Gains Tax
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="capitalGainsDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_CGT',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/cgt-dashboard']"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_CGT',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/cgt-assessments']"
										>Assessments</a
									>
								</div>
							</li>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_GENERATE_MANUAL_CGT_DEMAND_NOTICE',
									])
								"
								class="subLinks"
								ngbDropdownItem
								[routerLink]="['/admin/manual-cgt-assessments']"
								>Generate Manual CGT Demand Notice</a
							>

							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_OTHER_TAXES',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="whtDropdown"
									role="button"
									>Withholding Tax
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="whtDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_WHT',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/wht-dashboard']"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_WHT',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/wht-assessment']"
										>Assessments</a
									>
								</div>
							</li>

							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_OTHER_TAXES',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="capitalGainsDropdown"
									role="button"
									>Stamp Duty
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="capitalGainsDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_STAMP_DUTY',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/stamp-duty-dashboard']"
										>Stamp Duty Dashboard</a
									>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_STAMP_DUTY',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/assessments/stamp-duty']"
										>Stamp Duty Instruments</a
									>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_CREATE_STAMP_DUTY',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/stampduty-landing']"
										>Stamp Duty Application</a
									>
								</div>
							</li>
						</div>
					</li>

					<li
						class="nav-item"
						ngbDropdown
						*ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_MDA'])"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown10"
							role="button"
							>MDA</a
						>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown5"
							class="dropdown-menu"
						>
							<a
								[routerLink]="['/general/bill-history']"
								class="subLinks"
								ngbDropdownItem
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_GENERATE_MDA_SERVICES',
									])
								"
								>Generate Bills</a
							>
							<a
								[routerLink]="['/general/mda']"
								class="subLinks"
								ngbDropdownItem
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_SET_MDA_SERVICES',
									])
								"
								>Set MDA Services</a
							>
						</div>
					</li>

					<li
						class="nav-item"
						ngbDropdown
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_VIEW_ASSESSMENT_BILLS',
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown14"
							role="button"
						>
							Bills/Mails
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown14"
							class="dropdown-menu"
						>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/assessments-bills']"
								>Assessment Bills</a
							>

							<li
								class="subdropdown-menu"
								ngbDropdown
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="directAssDropdown"
									role="button"
									>Serve Notice</a
								>
								<div
									ngbDropdownMenu
									aria-labelledby="directAssDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="['/admin/serve-notice']"
										>Assessments</a
									>

									<a
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/backduty-landing',
										]"
										>Backduty</a
									>
								</div>
							</li>

							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/office-mails']"
								>Office Mails</a
							>
						</div>
					</li>

					<li
						class="nav-item me-3"
						ngbDropdown
						*ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_PAYE'])"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown8"
							role="button"
						>
							PAYE
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown8"
							class="dropdown-menu"
						>
							<a
								*ngIf="hasAccess(['ALL_PERMISSIONS'])"
								class="subLinks pointer"
								ngbDropdownItem
								(click)="navTo('admin/paye/dashboard')"
								>PAYE Dashboard</a
							>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ANNUAL_RETURNS',
									])
								"
								class="subLinks pointer"
								ngbDropdownItem
								(click)="navigateToAnnualReturn('COMPANY')"
							>
								Annual Returns</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_CREATE_PAYE',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/assessments']"
								>PAYE Assessments</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_PAYE_TCC_MANUAL',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/paye/manual-assessments',
								]"
								>Manual PAYE Assessments</a
							>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_PAYE_ETCC',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/tcc']"
								>PAYE TCC</a
							>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_PAYE_REPORT',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/report']"
								>PAYE Report</a
							>

							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/collections']"
								>PAYE Collections</a
							>

							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/agents']"
								>PAYE Agents</a
							>

							<a
								*ngIf="hasAccess(['ALL_PERMISSIONS'])"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/tracking']"
								>Track PAYE Payments</a
							>
						</div>
					</li>

					<li
						class="nav-item me-3"
						ngbDropdown
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_VIEW_PAYE',
								'PAYE_STAFF',
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id=""
							role="button"
						>
							PAYE Account Module
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown8"
							class="dropdown-menu"
						>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/agents/module']"
								>PAYE Agent</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/agents/revenue']"
								>Agent Revenue</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/agent-report']"
								>Agent PAYE Report</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_TRACK_PAYE',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/paye/tracking']"
								>Track PAYE Payments</a
							>
						</div>
					</li>
					<li
						class="nav-item"
						ngbDropdown
						*ngIf="
							hasAccess([
								'CAN_ASSESSMENT_REPORT',
								'ALL_PERMISSIONS',
								'CAN_VIEW_ALL_ASSESSMENTS',
								'CAN_VIEW_ALL_NON_ASSESSMENTS',
								'CAN_APPROVE_ALL_ASSESSMENTS',
								'CAN_APPROVE_ALL_NON_ASSESSMENTS',
								'CAN_CREATE_ALL_ASSESSMENTS',
								'CAN_CREATE_ALL_NON_ASSESSMENTS',
								'CAN_CREATE_DIRECT_TAX',
								'CAN_VIEW_DIRECT_TAX',
								'CAN_APPROVE_DIRECT_TAX',
								'CAN_CREATE_HNI',
								'CAN_VIEW_HNI',
								'CAN_APPROVE_HIN',
								'CAN_CREATE_PRESUMPTIVE_TAX',
								'CAN_VIEW_PRESUMPTIVE_TAX',
								'CAN_APPROVE_PRESUMPTIVE_TAX',
								'CAN_VIEW_TCC',
								'CAN_CREATE_STAMP_DUTY',
								'CAN_VIEW_STAMP_DUTY',
								'CAN_VIEW_TAMA',
								'CAN_VIEW_EDL',
								'CAN_VIEW_BOJ',
								'CAN_APPROVE_STAMP_DUTY',
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown14"
							role="button"
						>
							Assessment
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown14"
							class="dropdown-menu"
						>
							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_HNI',
										'CAN_VIEW_HNI',
										'CAN_APPROVE_HIN',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="directAssDropdown"
									role="button"
									>Direct Assessments
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="directAssDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_ALL_ASSESSMENTS',
												'CAN_VIEW_ALL_NON_ASSESSMENTS',
												'CAN_APPROVE_ALL_ASSESSMENTS',
												'CAN_APPROVE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_ALL_ASSESSMENTS',
												'CAN_CREATE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_DIRECT_TAX',
												'CAN_VIEW_DIRECT_TAX',
												'CAN_APPROVE_DIRECT_TAX',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/dashboard',
										]"
										>Dashboard</a
									>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_ALL_ASSESSMENTS',
												'CAN_VIEW_ALL_NON_ASSESSMENTS',
												'CAN_APPROVE_ALL_ASSESSMENTS',
												'CAN_APPROVE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_ALL_ASSESSMENTS',
												'CAN_CREATE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_DIRECT_TAX',
												'CAN_VIEW_DIRECT_TAX',
												'CAN_APPROVE_DIRECT_TAX',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/direct-assessments',
										]"
										>Assessments</a
									>
								</div>
							</li>

							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_HNI',
										'CAN_VIEW_HNI',
										'CAN_APPROVE_HIN',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="hniDropdown"
									role="button"
									>HNI Assessments
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="hniDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_CGT',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/assessments/hni-dashboard']"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_ALL_ASSESSMENTS',
												'CAN_VIEW_ALL_NON_ASSESSMENTS',
												'CAN_APPROVE_ALL_ASSESSMENTS',
												'CAN_APPROVE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_ALL_ASSESSMENTS',
												'CAN_CREATE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_HNI',
												'CAN_VIEW_HNI',
												'CAN_APPROVE_HIN',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/hni-assessments',
										]"
									>
										HNI Assessments</a
									>
								</div>
							</li>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_MARKET',
										'CAN_VIEW_MARKET',
										'CAN_APPROVE_MARKET',
										'CAN_CREATE_DIRECT_TAX',
										'CAN_VIEW_DIRECT_TAX',
										'CAN_APPROVE_DIRECT_TAX',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/assessments/market-assessments',
								]"
								>Market Assessments</a
							>

							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_PRESUMPTIVE_TAX',
										'CAN_VIEW_PRESUMPTIVE_TAX',
										'CAN_APPROVE_PRESUMPTIVE_TAX',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="hniDropdown"
									role="button"
									>Presumptive Tax
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="hniDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_CGT',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/assessments/presumptive-tax-dashboard']"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_ALL_ASSESSMENTS',
												'CAN_VIEW_ALL_NON_ASSESSMENTS',
												'CAN_APPROVE_ALL_ASSESSMENTS',
												'CAN_APPROVE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_ALL_ASSESSMENTS',
												'CAN_CREATE_ALL_NON_ASSESSMENTS',
												'CAN_CREATE_PRESUMPTIVE_TAX',
												'CAN_VIEW_PRESUMPTIVE_TAX',
												'CAN_APPROVE_PRESUMPTIVE_TAX',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/presumptive-tax',
										]"
										>Assessments</a
									>
								</div>
							</li>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_VIEW_TCC',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/assessments/e-tcc']"
								>eTCC</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ANNUAL_RETURNS',
									])
								"
								class="subLinks pointer"
								ngbDropdownItem
								(click)="navigateToAnnualReturn('INDIVIDUAL')"
								>Annual Returns</a
							>
							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_BOJ',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="hniDropdown"
									role="button"
									>BOJ Assessments
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="hniDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_BOJ',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/assessments/boj-assessments/dashboard']"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_BOJ',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/boj-assessments',
										]"
										>Assessments</a
									>
								</div>
							</li>

							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_TAMA',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="tamaDropdown"
									role="button"
									>TAMA Application
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="tamaDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_TAMA',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="[
											'/admin/assessments/tama/dashboard',
										]"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_TAMA',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/tama-applications',
										]"
										>TAMA Application</a
									>
								</div>
							</li>

							<li
								class="subdropdown-menu"
								ngbDropdown
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_TAAS',
									])
								"
							>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="taasDropdown"
									role="button"
									>TAAS Application
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="taasDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_TAAS',
											])
										"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="[
											'/admin/assessments/taas/dashboard',
										]"
										>Dashboard</a
									>

									<a
										*ngIf="
											hasAccess([
												'ALL_PERMISSIONS',
												'CAN_VIEW_TAAS',
											])
										"
										class="subLinks"
										ngbDropdownItem
										href="#"
										[routerLink]="[
											'/admin/assessments/taas-applications',
										]"
										>TAAS Application</a
									>
								</div>
							</li>

							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
									])
								"
								class="subLinks pointer"
								ngbDropdownItem
								[routerLink]="[
									'/admin/assessments/backduty-assessments',
								]"
								>Backduty Assessments</a
							>
							<li class="subdropdown-menu"
								ngbDropdown>
								<a
									tabindex="0"
									ngbDropdownToggle
									id="taasDropdown"
									role="button"
									>VAIDS
								</a>
								<div
									ngbDropdownMenu
									aria-labelledby="taasDropdown"
									class="dropdown-menu"
									style="left: calc(95%); top: 20%"
								>
									<a
										*ngIf="hasAccess(['ALL_PERMISSIONS', 'ADMIN'])"
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/vaids']"
										>Applications</a
									>
									<a
										class="subLinks"
										ngbDropdownItem
										[routerLink]="['/admin/vaids/assessments']"
										>Assessment</a
									>
								</div>
							</li>
						</div>
					</li>

					<li
						class="nav-item"
						ngbDropdown
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_VIEW_ALL_ASSESSMENTS',
								'CAN_VIEW_ALL_NON_ASSESSMENTS',
								'CAN_APPROVE_ALL_ASSESSMENTS',
								'CAN_APPROVE_ALL_NON_ASSESSMENTS',
								'CAN_CREATE_ALL_ASSESSMENTS',
								'CAN_CREATE_ALL_NON_ASSESSMENTS',
								'CAN_CREATE_DIRECT_TAX',
								'CAN_VIEW_DIRECT_TAX',
								'CAN_APPROVE_DIRECT_TAX',
								'CAN_CREATE_HNI',
								'CAN_VIEW_HNI',
								'CAN_APPROVE_HIN',
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown15"
							role="button"
						>
							Reconciliation
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown15"
							class="dropdown-menu"
						>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/reconciliations/assessment-reconciliation',
								]"
								>Reconcile Assessment</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/general/reconciliations/payment-reconciliation',
								]"
							>
								Payment Reconciliation
							</a>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/general/reconciliations/payment/check-status',
								]"
							>
								Check Payment Status
							</a>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/reconciliations/asin-reconciliation',
								]"
							>
								ASIN Reconciliation
							</a>
						</div>
					</li>

					<li
						class="nav-item"
						ngbDropdown
						*ngIf="
							hasAccess([
								'CAN_VIEW_ALL_ASSESSMENTS',
								'CAN_VIEW_ALL_NON_ASSESSMENTS',
								'CAN_APPROVE_ALL_ASSESSMENTS',
								'CAN_APPROVE_ALL_NON_ASSESSMENTS',
								'CAN_CREATE_ALL_ASSESSMENTS',
								'CAN_CREATE_ALL_NON_ASSESSMENTS',
								'CAN_CREATE_NON_TAX',
								'ALL_PERMISSIONS',
								'CAN_VIEW_PENALTY_ASSESSMENT'
							])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="nonTaxDropdown"
							role="button"
						>
							Non-Tax
						</a>
						<div
							ngbDropdownMenu
							aria-labelledby="nonTaxDropdown"
							class="dropdown-menu"
						>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ASWAMA',
										'CAN_APPROVE_ASWAMA',
										'CAN_VIEW_ASWAMA',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/non-tax-assessments/dashboard',
								]"
								>Dashboard</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ASWAMA',
										'CAN_APPROVE_ASWAMA',
										'CAN_VIEW_ASWAMA',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/non-tax-assessments/aswama',
								]"
								>ASWAMA</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_BUSINESS_PREMISES',
										'CAN_APPROVE_BUSINESS_PREMISES',
										'CAN_VIEW_BUSINESS_PREMISES',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/non-tax-assessments/business-premises',
								]"
								>Business Premises</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_FIRE_SERVICE',
										'CAN_APPROVE_FIRE_SERVICE',
										'CAN_VIEW_FIRE_SERVICE',
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/non-tax-assessments/fire-service',
								]"
								>Fire Service</a
							>
							<a
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ALL_ASSESSMENTS',
										'CAN_VIEW_ALL_NON_ASSESSMENTS',
										'CAN_APPROVE_ALL_ASSESSMENTS',
										'CAN_APPROVE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_ALL_ASSESSMENTS',
										'CAN_CREATE_ALL_NON_ASSESSMENTS',
										'CAN_CREATE_FIRE_SERVICE',
										'CAN_APPROVE_FIRE_SERVICE',
										'CAN_VIEW_FIRE_SERVICE',
										'CAN_VIEW_EDL',
										'CAN_VIEW_PENALTY_ASSESSMENT'
									])
								"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/non-tax-assessments/edl',
								]"
								>EDL Assessments</a
							>
							<a
								*ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_ALL_ASSESSMENTS', 'CAN_VIEW_ALL_NON_ASSESSMENTS', 'CAN_APPROVE_ALL_ASSESSMENTS', 'CAN_APPROVE_ALL_NON_ASSESSMENTS', 'CAN_CREATE_ALL_ASSESSMENTS', 'CAN_CREATE_ALL_NON_ASSESSMENTS', 'CAN_CREATE_CONSOLIDATED_ASSESSMENT', 'CAN_APPROVE_CONSOLIDATED_ASSESSMENT', 'CAN_VIEW_CONSOLIDATED_ASSESSMENT'])"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/non-tax-assessments/consolidated-assessment']"
							>Consolidated Assessment</a
							>
							<a
								*ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_PENALTY_ASSESSMENT'])"
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/non-tax-assessments/penalty-assessment']"
							>Penalty Assessments</a
							>
						</div>
					</li>

					<li
						class="nav-item"
						ngbDropdown
						*ngIf="
							hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_REPORT'])
						"
					>
						<a
							class="nav-link links"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							tabindex="0"
							ngbDropdownToggle
							id="navbarDropdown12"
							role="button"
						>
							Reports</a
						>
						<div
							ngbDropdownMenu
							aria-labelledby="navbarDropdown12"
							class="dropdown-menu"
						>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="[
									'/admin/reports/assessment-reports',
								]"
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ASSESSMENT_REPORT',
									])
								"
								>Assessment</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/reports/collections']"
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_COLLECTIONS_REPORT',
									])
								"
								>Collections</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/reports/asin-reports']"
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_ASIN_REPORT',
									])
								"
								>Enumeration Charts</a
							>
							<a
								class="subLinks"
								ngbDropdownItem
								href="#"
								[routerLink]="['/admin/reports/visualization']"
								*ngIf="
									hasAccess([
										'ALL_PERMISSIONS',
										'CAN_VIEW_VISUALIZATION_REPORT',
									])
								"
								>Revenue Charts</a
							>
							<a class="subLinks" ngbDropdownItem href="#" [routerLink]="['/admin/reports/officer-target']" *ngIf="hasAccess(['ALL_PERMISSIONS','CAN_VIEW_TARGET'])">Target Reports</a>
							<a class="subLinks" ngbDropdownItem href="#" [routerLink]="['/admin/zone-report']" *ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_ZONAL_TARGET'])">Zonal Target Report</a>
							<a class="subLinks" ngbDropdownItem href="#" [routerLink]="['/admin/my-target']" *ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_MY_TARGET'])">My Target Report</a>
							<a class="subLinks" ngbDropdownItem href="#" [routerLink]="['/admin/station-target']" *ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_STATION_TARGET'])">Station Report</a>
							<a class="subLinks" ngbDropdownItem href="#" [routerLink]="['/admin/reports/data-request']" *ngIf="hasAccess(['ALL_PERMISSIONS'])">Data Request Submissions</a>
						</div>
					</li>

					<li
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_VIEW_SUPPORT',
								'CAN_EDIT_PAYMENT_ASIN',
								'CAN_EDIT_PAYMENT_REVENUE_CODE',
							])
						"
						class="nav-item me-3"
						style="white-space: nowrap; display: inline-block"
					>
						<a
							href="#"
							class="nav-link links"
							[routerLink]="['/admin/support-staff']"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							>Support</a
						>
					</li>
					<li
						*ngIf="
							hasAccess([
								'ALL_PERMISSIONS',
								'CAN_VIEW_ENUMERATION',
							])
						"
						class="nav-item me-3"
						style="white-space: nowrap; display: inline-block"
					>
						<a
							href="#"
							class="nav-link links"
							[routerLink]="['/admin/enumeration-dashboard']"
							style="
								color: #fff;
								font-family: Inter;
								font-size: 14px;
								font-style: normal;
							"
							>Enumeration</a
						>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</div>
